import React from 'react';

import DataTable from '../../shared/data_table';
import StatusPill from '../../shared/status_pill';

/*
 * PROD-7828 R9 — the month's uploads, newest first, each with its original file (kept forever as
 * evidence, D93). The file link is signed for 15 minutes, so it is fetched on request, not per row.
 * links: { [run_uuid]: { busy, url, expires_text, error } }. Props-only.
 */
const HistoryTable = ({ rows, links, on_open, on_link }) => {
  const file_cell = (r) => {
    const link = links[r.run_uuid] || {};
    if (link.url) {
      return (
        <span>
          <a className="tp-link" href={link.url} target="_blank" rel="noopener noreferrer">
            Open the original file
          </a>
          {link.expires_text ? (
            <div className="tp-card-field-label">{link.expires_text}</div>
          ) : null}
        </span>
      );
    }
    return (
      <span>
        {/* aria-disabled, not disabled: the pressed button keeps focus while the link loads (CD-114). */}
        <button
          type="button"
          className="tp-link"
          onClick={link.busy ? undefined : () => on_link(r.run_uuid)}
          aria-disabled={link.busy ? 'true' : undefined}
        >
          {link.busy ? 'Getting the link…' : 'Get the file link'}
        </button>
        {link.error ? (
          <div className="tp-err" role="alert">
            {link.error}
          </div>
        ) : null}
      </span>
    );
  };

  const columns = [
    { key: 'file_name', label: 'File', hideInCard: true },
    {
      key: 'status',
      label: 'Status',
      render: (r) => <StatusPill tone={r.status_tone}>{r.status_label}</StatusPill>
    },
    { key: 'uploaded_text', label: 'Uploaded' },
    { key: 'counts_text', label: 'Rows' },
    { key: 'outcome_text', label: 'Outcome', render: (r) => r.outcome_text || '—' },
    {
      key: 'actions',
      label: 'Actions',
      render: (r) => (
        <span className="tp-actions">
          <button type="button" className="tp-link" onClick={() => on_open(r.run_uuid)}>
            View rows
          </button>
          {file_cell(r)}
        </span>
      )
    }
  ];
  return (
    <DataTable
      columns={columns}
      rows={rows}
      rowKey={(r) => r.key}
      cardTitle={(r) => <b>{r.file_name}</b>}
      emptyText="No uploads for this month yet."
    />
  );
};

export default HistoryTable;
